










import { Component, Vue, Prop } from "vue-property-decorator";
import SupportTooltip from "@/components/Support/SupportTooltip.vue";

@Component({
  components: { SupportTooltip },
})
export default class SupportIcon extends Vue {
  @Prop({ required: true }) message: string;
  @Prop({ required: true }) isSetMarginLeft: boolean;
}
